import { ToggleSwitchDesignTokens } from '@primeuix/themes/types/toggleswitch';

export const toggleswitch: ToggleSwitchDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        background: '{surface.700}',
        hoverBackground: '{surface.600}',
        checkedBackground: '{surface.700}',
        checkedHoverBackground: '{surface.600}',
        borderColor: '{surface.700}',
        hoverBorderColor: '{primary.color}',
        checkedBorderColor: '{surface.700}',
        checkedHoverBorderColor: '{primary.color}',
      },
      handle: {
        background: '{primary.color}',
        hoverBackground: '{primary.color}',
        checkedBackground: '{primary.color}',
        checkedHoverBackground: '{primary.color}',
        color: '{surface.700}',
        hoverColor: '{surface.700}',
        checkedColor: '{primary.color}',
        checkedHoverColor: '{primary.color}',
      },
    },
  },
};
